/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { ID } from '@gh/common-shared-data';
import { AbstractRestService, arrayOf, none, RestSettings, identity } from '@gh/core-data';
import { parametrizeUrl } from '@gh/core-util';

import { Observable } from 'rxjs';

import { DrawRuleDetailsDto, DrawRuleListItemDto, DrawRuleSaveDto, DrawRuleStageDto } from './draw-rule.dto';
import { DrawRuleDetailsMapper, DrawRuleListItemMapper, DrawRuleSaveMapper } from './draw-rule.mapper';

@Injectable()
export class DrawRuleRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  findAll(): Observable<DrawRuleListItemDto[]> {
    return this.httpGet(`${this.bp}/draw-rules`, arrayOf(DrawRuleListItemMapper));
  }

  checkUsage(drawRule: DrawRuleListItemDto): Observable<void> {
    const { id, version } = drawRule;
    return this.httpGet(
      `${this.bp}/draw-rules/${id}/check-usage`,
      { version },
      void 0,
      none(),
    );
  }

   checkStageUsage(ruleId: ID, drawRuleStage: DrawRuleStageDto): Observable<any> {
     const { drawRuleStageId } = drawRuleStage;
     return this.httpGet(
       `${this.bp}/draw-rules/${ruleId}/stages/${drawRuleStageId}/status`,
       {},
       void 0,
       identity(),
     );
   }

  remove(drawRule: DrawRuleListItemDto): Observable<void> {
    const { id, version } = drawRule;
    return this.httpDelete(
      parametrizeUrl(`${this.bp}/draw-rules/${id}`, { version }),
      void 0,
      none());
  }

  getInit(): Observable<DrawRuleDetailsDto> {
    return this.httpGet(`${this.bp}/draw-rules/init`, DrawRuleDetailsMapper);
  }

  get(drawRuleId: ID): Observable<DrawRuleDetailsDto> {
    return this.httpGet(`${this.bp}/draw-rules/${drawRuleId}`, DrawRuleDetailsMapper);
  }

  clone(drawRuleId: ID): Observable<DrawRuleDetailsDto> {
    return this.httpGet(`${this.bp}/draw-rules/${drawRuleId}/clone`, DrawRuleDetailsMapper);
  }

  create(drawRule: DrawRuleSaveDto): Observable<DrawRuleDetailsDto> {
    return this.httpPost(`${this.bp}/draw-rules`, drawRule, DrawRuleSaveMapper, DrawRuleDetailsMapper);
  }

  update(drawRule: DrawRuleSaveDto): Observable<DrawRuleDetailsDto> {
    return this.httpPut(`${this.bp}/draw-rules/${drawRule.drawRuleId}`, drawRule, DrawRuleSaveMapper, DrawRuleDetailsMapper);
  }
}
